import PropTypes from 'prop-types';

export const LocationPropTypes = PropTypes.shape({
    locationId: PropTypes.number,
    tripTypeFk: PropTypes.number,
    location: PropTypes.string,
    active: PropTypes.number,
    shortcode: PropTypes.string,
    scubadatesId: PropTypes.number,
    scubadatesKey: PropTypes.string,
    liveaboardhubId: PropTypes.number,
    email_notify: PropTypes.string,
});

export const PortFeePropTypes = PropTypes.shape({
    feeAmount: PropTypes.number,
    feeComment: PropTypes.string,
});

export const ParkFeePropTypes = PropTypes.shape({
    rewardId: PropTypes.number,
    tripClassFk: PropTypes.number,
    perDay: PropTypes.number,
    startdate: PropTypes.string,
    description: PropTypes.string,
    tripBaseLength: PropTypes.number,
    daysReward: PropTypes.number,
    extraDays: PropTypes.number,
    redeemable: PropTypes.number,
    startBookDate: PropTypes.string,
    rewardDays: PropTypes.number,
});

export const PreTripInfoPropTypes = PropTypes.shape({
    imagePreTrip: PropTypes.string,
    pdfFile: PropTypes.string,
});

export const TripClassInfoPropTypes = PropTypes.shape({
    tripClassId: PropTypes.number,
    active: PropTypes.number,
    class: PropTypes.string,
    shortclass: PropTypes.string,
    scubadatesId1: PropTypes.string,
    scubadatesId2: PropTypes.string,
    scubadatesId3: PropTypes.string,
    liveaboardhubId: PropTypes.number,
    ratingsclass: PropTypes.string,
    headerImage: PropTypes.string,
    thumbnail_path: PropTypes.string,
    tripTypeFk: PropTypes.number,
    diveExpDescription: PropTypes.string,
});

export const SeasonPropTypes = PropTypes.shape({
    seasonId: PropTypes.number,
    active: PropTypes.number,
    locationFk: PropTypes.number,
    tripClassFk: PropTypes.number,
    userFk: PropTypes.number,
    year: PropTypes.number,
    nights: PropTypes.number,
    updated: PropTypes.string,
    startdate: PropTypes.string,
    enddate: PropTypes.string,
    season: PropTypes.string,
    description: PropTypes.string,
    maxpax: PropTypes.number,

    season_room: PropTypes.arrayOf(PropTypes.shape({
        seasonFk: PropTypes.number,
        roomNameFk: PropTypes.number,
        capacity: PropTypes.number,
        roomClassFk: PropTypes.number,
        roomClass2Fk: PropTypes.number,
    })),
});

export const TripPropTypes = PropTypes.shape({
    TripId: PropTypes.number.isRequired,
    shipFk: PropTypes.number.isRequired,
    locationFk: PropTypes.number.isRequired,
    seasonFk: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    length: PropTypes.number.isRequired,
    yr: PropTypes.number.isRequired,
    tripFlagFk: PropTypes.number.isRequired,
    boardPortFk: PropTypes.number.isRequired,
    returnPortFk: PropTypes.number.isRequired,
    boarddate: PropTypes.string.isRequired,
    boardtime: PropTypes.string.isRequired,
    returndate: PropTypes.string.isRequired,
    returntime: PropTypes.string.isRequired,
    depart: PropTypes.string,
    arrive: PropTypes.string,
    charterRate: PropTypes.number.isRequired,
    charterRateTaxIn: PropTypes.number.isRequired,
    price1: PropTypes.number.isRequired,
    price2: PropTypes.number,
    price3: PropTypes.number,
    gst: PropTypes.number.isRequired,
    ExecNonDiver: PropTypes.number,
    StateNonDiver: PropTypes.number,
    avail1: PropTypes.number,
    avail2: PropTypes.number,
    avail3: PropTypes.number,
    visible: PropTypes.number.isRequired,
    d1: PropTypes.number,
    d2: PropTypes.number,
    d3: PropTypes.number,
    d4: PropTypes.number,
    comment: PropTypes.string,
    shortcomment: PropTypes.string,
    sea: PropTypes.number.isRequired,
    thirdperson: PropTypes.number,
    ExecEmpty: PropTypes.number,
    StateEmpty: PropTypes.number,
    DormEmpty: PropTypes.number,
    ExecSharedEmpty: PropTypes.number,
    SharedEmpty: PropTypes.number,
    Pax: PropTypes.number,
    boardNotes: PropTypes.string,
    sailNotes: PropTypes.string,
    sailNotes2: PropTypes.string,
    disembarkNotes: PropTypes.string,
    disembarkNotes2: PropTypes.string,
    disembarkNotes3: PropTypes.string,
    sailTime: PropTypes.string,
    price4: PropTypes.number,
    price5: PropTypes.number,
    price6: PropTypes.string,
    PremiumNonDiver: PropTypes.number,
    avail4: PropTypes.number,
    avail5: PropTypes.number,
    avail6: PropTypes.number,
    PremiumEmpty: PropTypes.number,
    PremiumSharedEmpty: PropTypes.number,
    TriStateEmpty: PropTypes.number,
    TriStateSharedEmpty: PropTypes.number,
    TriStateNonDiver: PropTypes.number,
    TriStateBeds: PropTypes.number,
    ship: PropTypes.string,
    ItineraryId: PropTypes.number,
    price1CDN: PropTypes.number,
    price2CDN: PropTypes.number,
    price3CDN: PropTypes.number,
    price4CDN: PropTypes.number,
    price5CDN: PropTypes.number,
    price6CDN: PropTypes.string,
    featured: PropTypes.number,
    PromoId: PropTypes.number,
    SharedInfo: PropTypes.any,
    sentCaptainLetter: PropTypes.number,
    bahiaNights: PropTypes.number,
    bahiaItineraryId: PropTypes.number,
    bahiaOption: PropTypes.number,
    bahiaBerths: PropTypes.number,
    bahiaPrice: PropTypes.number,
    maxPax: PropTypes.number,
    thumbnail_path: PropTypes.string,
    hero_path: PropTypes.string,
    migrated: PropTypes.number,
    available: PropTypes.string,

    portFee: PortFeePropTypes,
    parkFee: ParkFeePropTypes,

    tripClass: PropTypes.string,
    singleSurcharge: PropTypes.number,
    space1: PropTypes.number,
    space2: PropTypes.number,
    space3: PropTypes.number,
    space4: PropTypes.number,
    space5: PropTypes.number,
    tripImageCard: PropTypes.string,
    tripClassName: PropTypes.string,

    preTripInfo: PreTripInfoPropTypes,
    locationInfo: LocationPropTypes,
    trip_class_info: TripClassInfoPropTypes,
    season: SeasonPropTypes,
    location: LocationPropTypes,

});